import React, {useState, useEffect, forwardRef, useRef, useImperativeHandle} from 'react';
import {useTranslation} from 'react-i18next';
import ListDropDown from './list-dropdown';
import BoardConst from '../../../utils/constants/board';
import TextField from '../../../../styled-base/input/text';
import BoardService from '../../../services/board.service';
import ImgIconComp from '../../../../components/imgcomp';
import OwnerListComp from '../../../components/sidePanel/components/ownerList';
import {useDispatch} from 'react-redux';
import {updateColumnAutomationData} from '../../../actions/column.actions';
import moment from 'moment';
import {constructWsAutomationData} from '../../../utils/board';

const boardService = new BoardService();

const WorkstreamAutomation = forwardRef(({columnId, data, onClose}: any, ref: any) => {
    const { t } = useTranslation();
    const initialData: any = data || {};
    const ownerRef = useRef(null);
    const dispatch = useDispatch();
    const [automationData, setAutomationData] = useState<any>(initialData);
    const [startDate, setStartDate] = useState<any>(initialData.duedate);
    const [endDate, setEndDate] = useState<any>(initialData.todate);
    const [error, setError] = useState<string>('');
    
    useEffect(() => {
        initCalender('list-startdate', 'duedate');
        initCalender('list-targetdate', 'todate');
    }, []);

    useImperativeHandle(ref, () => ({
        onReset() {
            setAutomationData(initialData);
            setStartDate(initialData.duedate);
            setEndDate(initialData.todate);
        },
        async onDone() {
            if (isCompareDates()) {
                setError(t('Start date should be less than End Date'));
                return;
            }
            showLoaderWidget(document.getElementById('content'));
            let params: any = {columnId};
            const fields = ['status', 'pace', 'health', 'priority', 'owner'];
            for(let f in automationData) {
                if (fields.includes(f)) {
                    params[`autoWs${f}`] = automationData[f].id;
                }
                else if (f == 'duedate') {
                    params.colAutoDuedate = startDate.start_date;
                }
                else if (f == 'todate') {
                    params.colAutoFromdate = endDate.end_date;
                }
            }
            const response = await boardService.saveColAutomationWsData(params);
            const responseData = response.data.response;
            console.log('params', responseData);
            let data: any = constructWsAutomationData(responseData);
            dispatch(updateColumnAutomationData(columnId, responseData.isAutomated, data));
            removeLoader();
            onClose();
        }
    }));

    const isCompareDates = () => {
        const startDate1 = startDate.start_date;
        const endDate1 = endDate.end_date;
        if (startDate1 && endDate1) {
            return moment(startDate1).diff(moment(endDate1)) >= 0;
        }
        return false;
    }

    const setDateValue = (date: any, fieldName: any) => {
        //console.log('value', date, fieldName);
        let value: any = {};
        if (fieldName == 'duedate') {
            value.start_date = date;
            setStartDate(value);
        }
        if (fieldName == 'todate') {
            value.end_date = date;
            setEndDate(value);
        }
        if (error) setError('');
    }
    const initCalender = (id: string, dateField: string) => {
        const {duedate, todate} = automationData;
        const fieldElement = `#${id}`;
        const datePickerOptions: any = {
          showAnim: "slide",
          dateFormat: "mm/dd/yy",
          onSelect(date: any) {
            if (dateField == "duedate") {
              ($('#list-targetdate') as any).datepicker("option", "minDate", date);
              setDateValue(date, dateField);
            } else if (dateField == "todate") {
                ($('#list-startdate') as any).datepicker("option", "maxDate", date);
                setDateValue(date, dateField);
            }
          },
          onChangeMonthYear(year: any, month: any, inst: any) {
            const buttonPane = ($(inst.input) as any).datepicker("widget");
            $(buttonPane)
              .find("button.newStyleForDatePicker")
              .remove();
            setTimeout(() => {
                const btn: any = $(
                    `<button class=" clearstyles newStyleForDatePicker" type="button">${t('Clear')}</button>`
                );
                btn.off("click").on("click", () => {
                    ($ as any).datepicker._clearDate(inst.input);
                });
                if ($(".wbmodal-datepicker .newStyleForDatePicker").length == 0) {
                    btn.appendTo(buttonPane);
                }
                }, 1);
          },
          beforeShow(input: any) {
            $("#ui-datepicker-div").addClass("dataTimePicker wbmodal-datepicker");
            setTimeout(() => {
              const buttonPane = ($(input) as any).datepicker("widget");
              const btn: any = $(
                `<button class=" clearstyles newStyleForDatePicker" type="button" >${t('Clear')}</button>`
              );
              btn.off("click").on("click", () => {
                ($ as any).datepicker._clearDate(input);
              });
              if ($(".wbmodal-datepicker .newStyleForDatePicker").length == 0) {
                btn.appendTo(buttonPane);
              }
            }, 1);
          }
        };
        if (dateField == "duedate" && duedate.start_date) {
          datePickerOptions.maxDate = todate.end_date;
        }
        if (dateField == "todate" && todate.end_date) {
          datePickerOptions.minDate = duedate.start_date;
        }
        ($(fieldElement) as any).datepicker(datePickerOptions);
      }
    
    const openCalendar = (id: string) => ($(`#${id}`) as any).datepicker("show");
    const onSelect= (e: any, name: string, list: any) => {
        setAutomationData({...automationData, [name]: list});
    }

    const setOwnerName = (titleField: string, title: string, valueField: string, id: string) => {
        hideOwnerList();
        setAutomationData({...automationData, owner: {id, title}});
    }

    const hideOwnerList = () => {
        if (ownerRef.current) {
            ownerRef.current.hideOpenList(false);
        }
    }

    const renderAssigneeList = () => {
        return <OwnerListComp
        hideShowListPopup={hideOwnerList}
        savewsTitleAndwsValue={setOwnerName}
        srcVal="automationWs"
      />;
    }

    return (
        <div className='board-column-automation'>
            <div className='autoamtion-label'>
                {t('When an workstream is dropped on this column, set')}:
            </div>
            <div className='flex-row'>
                <div className='flex-label'>{t("Owner")}</div>
                <div>
                    <ListDropDown
                        title={t('owner')}
                        selectedValue={automationData.owner.title}
                        name='owner'
                        onSelect={onSelect}
                        optionsComp = {renderAssigneeList}
                        ref={ownerRef}
                    />
                </div>
            </div>
            <div className='flex-row'>
                <div className='flex-label'>{t('Status')}</div>
                <div>
                    <ListDropDown
                        title={t('Status')}
                        selectedValue={automationData.status.title}
                        name='status'
                        options={BoardConst.WS_STATUS_OPTIONS}
                        onSelect={onSelect}
                    />
                </div>
            </div>
            <div className='flex-row'>
                <div className='flex-label'>{t('Pace')}</div>
                <div>
                    <ListDropDown
                        title={t('Pace')}
                        selectedValue={automationData.pace.title}
                        name='pace'
                        options={BoardConst.WS_PACE_OPTIONS}
                        onSelect={onSelect}
                    />
                </div>
            </div>
            <div className='flex-row'>
                <div className='flex-label'>{t('Health')}</div>
                <div>
                    <ListDropDown
                        title={t('Health')}
                        name='health'
                        selectedValue={automationData.health.title}
                        options={BoardConst.WS_HEALTH_OPTIONS}
                        onSelect={onSelect}
                    />
                </div>
            </div>
            <div className='flex-row'>
                <div className='flex-label'>{t('Priority')}</div>
                <div>
                    <ListDropDown
                        title={t('Priority')}
                        name='priority'
                        selectedValue={automationData.priority.title}
                        options={BoardConst.WS_PRIORITY_OPTIONS}
                        onSelect={onSelect}
                    />
                </div>
            </div>
            <div className='flex-row'>
                <div className='flex-label'>{t('Due date')}</div>
                <div className='flex-row flex-nopadding'>
                    <div>
                        <TextField
                            inputProps = {{
                                id: 'list-startdate',
                                name: 'duedate',
                                placeholder: t('None'),
                                value: startDate.start_date,
                                style: {
                                    width: '72px',
                                    height: '28px',
                                    marginRight: '5px'
                                },
                                readOnly: true
                            }}
                        />
                        <span onClick={() => openCalendar('list-startdate')}>
                            <ImgIconComp class='list-calendar-icon' id="calendar" width="14" height="14" />
                        </span>
                    </div>
                    <div style={{lineHeight: '30px', margin: '0px 5px'}}>{t('to')}</div>
                    <div>
                        <TextField
                            inputProps = {{
                                id: 'list-targetdate',
                                name: 'todate',
                                placeholder: t('None'),
                                value: endDate.end_date,
                                style: {
                                    width: '72px',
                                    height: '28px',
                                    marginRight: '5px'
                                },
                                readOnly: true
                            }}
                        />
                        <span onClick={() => openCalendar('list-targetdate')}>
                            <ImgIconComp class='list-calendar-icon' id="calendar" width="14" height="14" />
                        </span>
                    </div>
                </div>
            </div>
            <div className='flex-row'>
                <div className='automation-error-text'>{error ? error : ''}</div>
            </div>
        </div>
    )
});

export default WorkstreamAutomation;